import React from 'react';
import { motion } from 'framer-motion';
const METRO_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/9pYpmBqnTFtudjrgYsyKLh/METRO-BRANDBOOK_Mesa_de_trabajo_1_copia_11.svg';
export function CoverSection() {
  return <section id="cover" className="min-h-screen flex items-center justify-center px-8 py-24" data-id="element-561">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-5xl w-full" data-id="element-562">
        <div className="space-y-12" data-id="element-563">
          <div className="space-y-8" data-id="element-564">
            <div className="font-mono text-xs text-[var(--text-muted)] tracking-wider" data-id="element-565">
              01 / IDENTITY
            </div>

            <div className="max-w-2xl" data-id="element-566">
              <img src={METRO_LOGO_URL} alt="me—tro" className="w-full h-auto" data-id="element-567" />
            </div>

            <div className="space-y-3 pt-4" data-id="element-568">
              <p className="text-xl md:text-2xl text-[var(--text-ink)] font-space font-light max-w-2xl" data-id="element-569">
                The hands-on agency.
              </p>
              <p className="text-sm text-[var(--text-muted)] max-w-2xl" data-id="element-570">
                A creative agency in Barcelona — brand system, version 2026.1
              </p>
            </div>
          </div>

          <div className="h-px bg-[var(--divider)]" data-id="element-571" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm" data-id="element-572">
            <div data-id="element-573">
              <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-574">
                VERSION
              </div>
              <div className="font-medium" data-id="element-575">v2026.1</div>
            </div>
            <div data-id="element-576">
              <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-577">
                LOCATION
              </div>
              <div className="font-medium" data-id="element-578">Barcelona, ES</div>
            </div>
            <div data-id="element-579">
              <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-580">
                EST.
              </div>
              <div className="font-medium" data-id="element-581">2023</div>
            </div>
          </div>

          <div className="mt-16 space-y-6" data-id="element-582">
            <div className="font-mono text-xs text-[var(--text-muted)] tracking-wider" data-id="element-583">
              LOGO
            </div>
            <div className="bg-[var(--bg-surface)] p-12 rounded-sm border border-[var(--divider)]" data-id="element-584">
              <div className="max-w-md mb-10" data-id="element-585">
                <img src={METRO_LOGO_URL} alt="me—tro" className="w-full h-auto" data-id="element-586" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-xs text-[var(--text-muted)]" data-id="element-587">
                <div data-id="element-588">
                  <div className="font-mono text-[var(--text-ink)] mb-1" data-id="element-589">
                    CLEARSPACE
                  </div>
                  <div className="font-space font-light" data-id="element-590">
                    0.5x cap height on all sides.
                  </div>
                </div>
                <div data-id="element-591">
                  <div className="font-mono text-[var(--text-ink)] mb-1" data-id="element-592">
                    MINIMUM SIZE
                  </div>
                  <div className="font-space font-light" data-id="element-593">
                    32px height (digital) / 12mm (print).
                  </div>
                </div>
                <div data-id="element-594">
                  <div className="font-mono text-[var(--text-ink)] mb-1" data-id="element-595">
                    USAGE
                  </div>
                  <div className="font-space font-light" data-id="element-596">
                    Use the master SVG. Do not redraw, recolor outside palette,
                    or apply effects.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-597">
            <div className="font-mono text-xs text-[var(--text-muted)] tracking-wider" data-id="element-598">
              COLORWAYS
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-599">
              <ColorwayCard bg="var(--bg-canvas)" filter="none" label="On canvas" data-id="element-600" />
              <ColorwayCard bg="#FFFFFF" filter="none" label="On white" data-id="element-601" />
              <ColorwayCard bg="#FFFFFF" filter="brightness(0)" label="Ink" data-id="element-602" />
              <ColorwayCard bg="var(--text-ink)" filter="brightness(0) invert(1)" label="Reverse" data-id="element-603" />
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}
function ColorwayCard({
  bg,
  filter,
  label
}: {
  bg: string;
  filter: string;
  label: string;
}) {
  return <div className="rounded-sm border border-[var(--divider)] p-8 flex flex-col items-center justify-between gap-6" style={{
    background: bg
  }} data-id="element-604">
      <div className="w-full flex-1 flex items-center justify-center min-h-24" data-id="element-605">
        <img src={METRO_LOGO_URL} alt="me—tro" className="w-full max-w-[140px] h-auto" style={{
        filter
      }} data-id="element-606" />
      </div>
      <div className={`font-mono text-[10px] tracking-wider ${bg === 'var(--text-ink)' ? 'text-white/60' : 'text-[var(--text-muted)]'}`} data-id="element-607">
        {label.toUpperCase()}
      </div>
    </div>;
}